import { render, staticRenderFns } from "./ArtigosManagementList.vue?vue&type=template&id=29e9da2d&scoped=true&"
import script from "./ArtigosManagementList.vue?vue&type=script&lang=js&"
export * from "./ArtigosManagementList.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosManagementList.vue?vue&type=style&index=0&id=29e9da2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e9da2d",
  null
  
)

export default component.exports